<template>
   <div class="create-bonus-module container-fluid"> 
      <!-- Create Bonus Lesson Overlay -->
        <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-1Perc cursor-pointer" v-on:click="updateShowCreateBonusOverlayFlag($event,false)">
                    <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <!-- <div class="row vertical-align margin-bottom-2Perc">
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Index
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="lessonIndexValue" disabled>
                        </div>
                    </div>
                </div> -->
                <!-- <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px"> -->
                  <!-- Is Optional -->
                <!-- </div>   -->
                <!-- <div class="col-md-3 col-lg-3 text-align-left vertical-align"> -->
                  <!-- <label class="switch">
                    <input type="checkbox" v-model="isOptionalLessonValue">
                    <span class="slider round"></span>
                  </label> -->
                <!-- </div>  
              </div> -->
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Title
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="lessonTitleValue">
                        </div>
                    </div>
                </div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px" v-if="!isBonusContentLessonValue">
                  <!-- Is Unlocked -->
                </div>  
                <div class="col-md-3 col-lg-3 text-align-left vertical-align">
                  <!-- <label class="switch" v-if="!isBonusContentLessonValue">
                    <input type="checkbox" v-model="lessonUnlockedValue">
                    <span class="slider round"></span>
                  </label> -->
                </div>  
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Release Date
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                          <date-picker v-model="date" :config="config"></date-picker>
                          <!-- <input type="text" class="form-control" v-model="lessonReleaseDateValue" placeholder="DD:MM:YYYY HH:MM AM/PM "> -->
                        </div>
                    </div>
                </div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Is Bonus Content
                </div>  
                <div class="col-md-3 col-lg-3 text-align-left vertical-align">
                  <label class="switch">
                    <input type="checkbox" v-model="isBonusContentLessonValue" disabled>
                    <span class="slider round"></span>
                  </label>
                </div>  
              </div>
              <!-- <div class="row vertical-align margin-bottom-2Perc">
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Duration
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="lessonDurationValue" disabled>
                        </div>
                    </div>
                </div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Is Published
                </div>  
                <div class="col-md-3 col-lg-3 text-align-left vertical-align">
                  <label class="switch">
                    <input type="checkbox" v-model="isPublishedLessonValue">
                    <span class="slider round"></span>
                  </label>
                </div>  
              </div> -->
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-4">
                </div>  
                <div class="col-md-2 col-lg-4">
                  <div class="col-lg-2">
                  </div>
                  <div class="col-lg-8">
                   <!-- ToDo: Track this -->
                   <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="createLesson">{{btnTxt}}</button>
                  </div>
                  <div class="col-lg-2">
                  </div>
                </div>  
                <div class="col-md-5 col-lg-4">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>
      <add-bonus-video-overlay v-if="showAddBonusVideoElementOverlay" v-bind:bonusModuleServerRespObj="bonusModuleRespObj" @closeAddBonusContent="upateAddBonusContentOverlayFlag" v-bind:comingFromLessonListAddOption="true" v-bind:selectedLessonObj="selectedLessonObj"></add-bonus-video-overlay>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
      <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="addVideoOperation"></confirmation-alert>
    </div> 
</template>
<script>
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import datePicker from 'vue-bootstrap-datetimepicker'
import { constants } from '@/utils/constants'
import { moduleService } from '@/server-util/module-service'
import AlertBox from '@/components/AlertOverlay'
import AddBonusVideoOverlay from '@/components/AddBonusVideoOverlay'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import Loader from '@/components/dashboard/Loader'
export default {
  props: ['selectedLessonObj'],
  name: 'create-bonus-module',
  created () {
    this.setCourseMasterId()
    this.setReleaseDate()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      moduleObj: {
        Index: null,
        Title: '',
        ReleaseDate: '',
        Duration: '',
        IsUnlocked: false,
        IsBonusContent: true,
        IsOptional: false,
        IsPublished: false,
        CourseMasterId: ''
      },
      bonusModuleRespObj: null,
      btnTxt: 'Create Bonus Content',
      showAddBonusVideoElementOverlay: false,
      showSpinner: false,
      showConfirmationBox: false,
      prefixString: '',
      postString: '',
      date: dmAdminUtils.getCurrentEst(),
      config: {
        format: 'MM/DD/YYYY hh:mm:ss A',
        useCurrent: true,
        sideBySide: true
      }
    }
  },
  components: {
    'alert-box': AlertBox,
    'add-bonus-video-overlay': AddBonusVideoOverlay,
    'confirmation-alert': ConfirmationOverlay,
    'date-picker': datePicker,
    'loader': Loader
  },
  methods: {
    addVideoOperation (value) {
      // AK: IF user pressed okay then show add video elements else ignore
      this.showConfirmationBox = false
      if (value) {
        // AK: Disable background scroll
        this.$store.state.isOverlayVisible = true
        // AK: Show add bonus content Overlay
        this.showAddBonusVideoElementOverlay = true
      }
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button confirmation overlay
      this.showConfirmationBox = value
      // AK: Update bonus module created flag as true since user get confirmation of add Video elements
      this.$emit('isBonusModuleCreated', true)
      // AK: Hide Bonus Module Creation Overlay also and show add Bonus content overlay which we hide initially
      this.$emit('closeBonusModuleOverlay', false)
    },
    upateAddBonusContentOverlayFlag (value) {
      // AK: Used to hide Add bonus content overlay
      this.$store.state.isOverlayVisible = value
      this.showAddBonusVideoElementOverlay = value
      // AK: Update bonus module created flag as true since user coming from add bonus video overlay
      this.$emit('isBonusModuleCreated', true)
      // AK: Hide Bonus Module Creation Overlay also and show add Bonus content overlay which we hide initially
      this.$emit('closeBonusModuleOverlay', false)
    },
    setCourseMasterId: function () {
      this.moduleObj.CourseMasterId = this.$store.state.selectedCourseObjFromFilter.CourseMasterId
    },
    setReleaseDate: function () {
      this.moduleObj.ReleaseDate = this.date
    },
    updateShowCreateBonusOverlayFlag: function (event, flagToUpdate) {
      // AK: user pressed X means he not created bonus module
      this.$emit('isBonusModuleCreated', false)
      // AK: Show again Bonus element add overlay
      this.$emit('closeBonusModuleOverlay', false)
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    createLesson: function (event) {
      if (this.validateRequiredFieldBeforeSubmit()) {
        var _this = this
        var storeObj = this.$store
        if (
          this.moduleObj.CourseMasterId !== undefined ||
          this.moduleObj.CourseMasterId !== '' ||
          this.moduleObj.length > 0
        ) {
          // AK: Start showing spinner
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
          // AK: Set selected Date before post
          _this.moduleObj.ReleaseDate = this.date
          moduleService
            .createModule(storeObj.state.access_token, _this.moduleObj)
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Refresh Lesson List
                _this.getLessons()
                // AK: Reset Obj before assign
                _this.bonusModuleRespObj = null
                if (_this.moduleObj.IsBonusContent) {
                  // AK: If created module is bonus then store it in another varible to pass
                  console.log(JSON.stringify(responseObj.data))
                  _this.bonusModuleRespObj = responseObj.data
                }
              } else {
                // AK: Hide Spinner
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Selected COURSEMASTERID Object is NULL hence declined CREATE BONUS LESSON OPERATION'
          )
        }
      }
    },
    validateRequiredFieldBeforeSubmit: function () {
      if (this.moduleObj.Title.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Title can\'t be empty.'
        return false
      } else if (this.date === null) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a release date.'
        return false
      }
      return true
    },
    getLessons: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.selectedCourseObjFromFilter.CourseMasterId !== undefined
      ) {
        moduleService
          .listModules(
            storeObj.state.access_token,
            storeObj.state.selectedCourseObjFromFilter.CourseMasterId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.selectedMasterClassModuleList = responseObj.data
              // AK: Hide Spinner after recieving with newly added Bonus Lesson
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              if (this.moduleObj.IsBonusContent) {
                this.showConfirmationBox = true
                this.prefixString = 'Do you want to add video(s) in the bonus lesson '
                this.postString = '\'' + this.moduleObj.Title + '\'?'
              }
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'CourseMasterId is NULL hence declined REFRESH LESSON LIST OPERATION'
        )
      }
    }
  },
  computed: {
    getCurrentlySelectedCourseObj: {
      get: function () {
        return this.$store.state.selectedCourseObjFromFilter
      }
    },
    lessonIndexValue: {
      get: function () {
        return this.moduleObj.Index
      },
      set: function (newValue) {
        if (newValue !== '') {
          this.moduleObj.Index = parseInt(newValue)
        } else {
          this.moduleObj.Index = null
        }
      }
    },
    lessonTitleValue: {
      get: function () {
        return this.moduleObj.Title
      },
      set: function (newValue) {
        this.moduleObj.Title = newValue
      }
    },
    lessonReleaseDateValue: {
      get: function () {
        return this.moduleObj.ReleaseDate
      },
      set: function (newValue) {
        this.moduleObj.ReleaseDate = newValue
      }
    },
    lessonDurationValue: {
      get: function () {
        return this.moduleObj.Duration
      },
      set: function (newValue) {
        this.moduleObj.Duration = newValue
      }
    },
    lessonUnlockedValue: {
      get: function () {
        return this.moduleObj.IsUnlocked
      },
      set: function (newValue) {
        this.moduleObj.IsUnlocked = newValue
      }
    },
    isBonusContentLessonValue: {
      get: function () {
        return this.moduleObj.IsBonusContent
      },
      set: function (newValue) {
        this.moduleObj.IsBonusContent = true
        this.btnTxt = 'Create Bonus Content'
        this.moduleObj.Index = ''
      }
    },
    isPublishedLessonValue: {
      get: function () {
        return this.moduleObj.IsPublished
      },
      set: function (newValue) {
        this.moduleObj.IsPublished = newValue
      }
    }
  }
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 25%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}

.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-21px {
  font-size: 21px;
}
.text-align-left {
  text-align: left;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.margin-top-3Perc {
  margin-top: 1%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/CreateBonusModuleOverlay.vue